import React, { Component } from "react"
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet-async';
import {
    Container,
    Row,
    Col,
} from "reactstrap"
import { ToastContainer } from "react-toastify";

import LatestBlockedOrdersList from "./list";
import { withTranslation } from "react-i18next"
import Breadcrumbs from "../../components/Common/Breadcrumb"

// Utilities
import {
    createNotificationHelpers,
    loadLatestBlockedOrdersData,
    LATEST_BLOCKED_ORDERS_TABLE_COLUMNS,
    transformLatestBlockedOrdersToTableData,
    MESSAGES
} from "../utils";

class BlockedOrders extends Component {
    constructor(props) {
        super(props)
        this.state = {
            TotalOrders: 0,
            OrdersDetails: [],
            loading: false
        }

        // Initialize notification helpers
        const notifications = createNotificationHelpers();
        this.notify_info = notifications.notify_info;
        this.notify_error = notifications.notify_error;
        this.notify_success = notifications.notify_success;
    }

    /**
     * Loads latest blocked orders from API and updates state
     */
    loadOrders = async () => {
        this.setState({ loading: true });

        const orders = await loadLatestBlockedOrdersData(this.notify_error);

        if (orders) {
            const data = transformLatestBlockedOrdersToTableData(orders, LATEST_BLOCKED_ORDERS_TABLE_COLUMNS);

            this.setState({
                TotalOrders: orders.length,
                OrdersDetails: data,
                loading: false
            });

            this.notify_success(MESSAGES.LATEST_BLOCKED_ORDERS_LOADED_SUCCESS);
        } else {
            this.setState({ loading: false });
        }
    }

    componentDidMount() {
        this.loadOrders();
    }

    render() {
        const { OrdersDetails, loading } = this.state;
        const { t } = this.props;

        return (
            <React.Fragment>
                <div className="page-content">
                    <Helmet>
                        <title>Veeper | AP - Latest Blocked Orders</title>
                    </Helmet>
                    <Container fluid>
                        <Breadcrumbs
                            title={t("Veeper Apps")}
                            breadcrumbItem={t("Veeper Analytics Overview")}
                        />
                        <ToastContainer />
                        <Row>
                            <Col xl={12}>
                                <LatestBlockedOrdersList loading={loading} orders={OrdersDetails} />
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

BlockedOrders.propTypes = {
    t: PropTypes.any
}

export default withTranslation()(BlockedOrders)
